module.exports = __webpack_public_path__ + "img/web_coaches_top@2x.7353bb55.jpg";